<template>
  <v-dialog
    :value="value"
    v-on:input="$emit('input', $event)"
    persistent
    :max-width="!confirm ? '600' : '300'"
  >
    <v-card v-show="!confirm">
      <v-card-title class="headline justify-center">
        <span>お知らせ確認</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <!-- Title -->
        <label for="title">
          タイトル
          <span class="red--text">*</span>
        </label>
        <v-text-field
          dense
          outlined
          id="title"
          :disabled="itemUpdate.type == 'REMOVE'"
          v-model="title"
          :error-messages="titleErrors"
          @input="$v.title.$touch()"
          @blur="$v.title.$touch()"
        ></v-text-field>
        <label for="title">
          詳細
          <span class="red--text">*</span>
        </label>
        <v-textarea
          class="mt-2"
          dense
          outlined
          :disabled="itemUpdate.type == 'REMOVE'"
          auto-grow
          v-model="content"
          :error-messages="contentErrors"
          @input="$v.content.$touch()"
          @blur="$v.content.$touch()"
        ></v-textarea>
        <v-row no-gutters class="min-width-3">
          <div>
            <!-- Create time -->
            <v-row no-gutters v-if="itemUpdate.unpublish_time">
              <v-col class="min-width-1 max-width-1">
                <strong class="mr-4">作成日時</strong>
              </v-col>
              <v-col>
                <p class="mb-0">{{ itemUpdate.unpublish_time | dateTime }}</p>
                <p class="mb-0">{{ itemUpdate.unpublish_email }}</p>
              </v-col>
            </v-row>
            <!-- Publish time -->
            <v-row no-gutters v-if="itemUpdate.publish_time">
              <v-col class="min-width-1 max-width-1">
                <strong class="mr-4">公開日時</strong>
              </v-col>
              <v-col>
                <p class="mb-0">{{ itemUpdate.publish_time | dateTime }}</p>
                <p class="mb-0">{{ itemUpdate.publish_email }}</p>
              </v-col>
            </v-row>
            <!-- Remove time -->
            <v-row no-gutters v-if="itemUpdate.remove_time">
              <v-col class="min-width-1 max-width-1">
                <strong>取り下げ日時</strong>
              </v-col>
              <v-col>
                <p class="mb-0">{{ itemUpdate.remove_time | dateTime }}</p>
                <p class="mb-0">{{ itemUpdate.remove_email }}</p>
              </v-col>
            </v-row>
          </div>

          <v-spacer />
          <strong class="mt-2 mr-3" for="type">公開状態</strong>
          <v-select
            id="type"
            :disabled="itemUpdate.type == 'REMOVE'"
            hide-details
            class="select-type"
            :items="typeList"
            v-model="type"
            dense
            item-text="text"
            item-value="type"
            outlined
          />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleHiddenDialog">キャンセル</v-btn>
        <v-btn
          color="primary"
          class="font-weight-bold"
          v-if="itemUpdate.type != 'REMOVE'"
          @click="handleHideShowConfirm"
          >決定</v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- Dialog confirm -->
    <v-card v-show="confirm">
      <v-card-title class="headline justify-center">
        <span>確認</span>
      </v-card-title>
      <v-card-text class="pb-0">
        <p class="mb-0">変更します。よろしいですか</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="font-weight-bold"
          :loading="loadingUpdateNotification"
          @click="updateMaintain"
          small
          >OK</v-btn
        >
        <v-btn @click="handleHideShowConfirm" small>キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
import { updateNotification } from "@/api/MasterData.api";
import vm from "@/main";
export default {
  props: ["value", "itemUpdate"],
  mixins: [mixin.ValidateNotification],
  data() {
    return {
      loadingUpdateNotification: false,
      confirm: false,
      title: "",
      content: "",
      type: "",
    };
  },
  filters: {
    dateTime: function (val) {
      const { $moment } = vm;
      if (!val) return "";
      return $moment.unix(val).format("YYYY年MM月DD HH:mm");
    },
  },
  computed: {
    typeList() {
      const { type } = this;
      if (type == "UNPUBLISH") {
        return [
          { type: "PUBLISH", text: "公開" },
          { type: "UNPUBLISH", text: "非公開" },
        ];
      } else if (type == "PUBLISH") {
        return [
          { type: "PUBLISH", text: "公開" },
          { type: "REMOVE", text: "取り下げ" },
        ];
      } else if (type == "REMOVE") {
        return [{ type: "REMOVE", text: "取り下げ" }];
      }
      return [];
    },
  },
  watch: {
    value: function (val) {
      if (val) {
        const { title, content, type } = this.itemUpdate;
        this.title = title;
        this.content = content;
        this.type = type;
      }
    },
  },
  methods: {
    async updateMaintain() {
      const { type, title, content } = this;
      this.loadingUpdateNotification = true;
      let params = {
        ...this.itemUpdate,
        id: this.itemUpdate.Id,
        title,
        content,
        type,
      };
      await updateNotification(params)
        .then(() => {
          this.confirm = !this.confirm;
          this.$emit("resetList");
          this.$emit("input", false);
        })
        .catch(({ code }) => {
          console.log("code: ", code);
        });
      this.loadingUpdateNotification = false;
    },
    handleHideShowConfirm() {
      const { startDate, startTime } = this;
      this.$v.$touch();
      this.dateTimeErrors = this.checkDateTimeStart(this.now);
      if (!this.$v.$anyError && !this.dateTimeErrors) {
        if (
          new Date(`${startDate} ${startTime}`).getTime() <=
          new Date().getTime()
        ) {
          return this.$toast.error(
            "開始時間は既に過ごしましたのでご確認ください。"
          );
        }
        this.confirm = !this.confirm;
      }
    },
    checkDateTimeStart(now) {
      const { startDate, startTime } = this;
      let start_Time = new Date(`${startDate} ${startTime}`).getTime();
      let time = new Date().getTime();
      if (now) return "";
      if (startDate == "" || startTime == "") {
        return "開始日時を選択してください。";
      } else if (start_Time < time) {
        return "過去の時間が登録できません。";
      }
      return "";
    },
    handleHiddenDialog() {
      this.$v.$reset();
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  min-width: 130px;
  margin-top: 10px;
  font-weight: bold;
}
.select-type {
  max-width: 130px;
}
</style>